import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { FacturacionElectronicaConsultarLogComponent } from './FacturacionElectronicaConsultarLog.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ConsultarLog',
        component: FacturacionElectronicaConsultarLogComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ConsultarLog'
        } 
    }
];

@NgModule({
    declarations: [
        FacturacionElectronicaConsultarLogComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        FacturacionElectronicaConsultarLogComponent
    ],
    bootstrap: [FacturacionElectronicaConsultarLogComponent]
})

export class FacturacionElectronicaConsultarLogModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaConsultarLog/FacturacionElectronicaConsultarLog.module.ts